module.exports = __webpack_public_path__ + "609ca265646702d36bd264d60d354c04.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/IR.svg
// module id = AXdl
// module chunks = 0